import { render, staticRenderFns } from "./ProvideStoreDataEffectOldVersion.vue?vue&type=template&id=fcbc07ba&"
import script from "./ProvideStoreDataEffectOldVersion.vue?vue&type=script&lang=ts&"
export * from "./ProvideStoreDataEffectOldVersion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports